<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Rapporter</h4>
      </div>
    </div>

    <div class="content-container flex-row no-flex-grow">
      <section class="content xlarge-padding">
        <div class="grid-x grid-padding-x grid-padding-large">
          <div class="cell" v-if="hasAccess('management')">
            <ul>
              <li><router-link :to="{ name: 'Politirapport' }">Politirapport</router-link></li>
              <li><router-link :to="{ name: 'StatsSalgEksperter' }">Salgstatistikk Eksperter</router-link></li>
            </ul>
          </div>

          <div class="cell" v-if="hasAccess('accounting')">
            <ul>
              <li><router-link :to="{ name: 'StatsFullobjekt' }">Objekt rapport</router-link></li>
            </ul>
          </div>

          <div class="cell" v-if="hasAccess('expert')">
            <ul>
              <li><router-link :to="{ name: 'Bekreftelsebrev' }">Bekreftelsebrev</router-link></li>
              <li><router-link :to="{ name: 'Resultatbrev' }">Resultatbrev</router-link></li>
              <li><router-link :to="{ name: 'StatsSalgKategori' }">Salgstatistikk Kategori</router-link></li>
              <li><router-link :to="{ name: 'Katalog' }">Katalog</router-link></li>
              <li><router-link :to="{ name: 'Besiktigelse' }">Besiktigelsesrapporter</router-link></li>
              <li><router-link :to="{ name: 'Manusliste' }">Manusliste for ekspertene</router-link></li>
              <li><router-link :to="{ name: 'ManuslisteKunde' }">Katalog tekstfil til trykkeri/Manusliste til kunde</router-link></li>
              <li v-if="isVin"><router-link :to="{ name: 'Vinrapport' }">Vinliste</router-link></li>
              <li><router-link :to="{ name: 'Auksjonsstatistikk' }">Auksjonsstatistikk</router-link></li>
              <li><router-link :to="{ name: 'StatsSalgEksperterProsentandel' }">Prosentandel salgseksperter</router-link></li>
              <li><router-link :to="{ name: 'StatsSalgKategoriUng' }">Salg Kategori Ung</router-link></li>
              <li><router-link :to="{ name: 'ObjectsPayingStorage' }">Lagerleieliste</router-link></li>
              <li><router-link :to="{ name: 'KnowYourCustomer' }">KYC (Know Your Customer)</router-link></li>
              <li><router-link :to="{ name: 'GjenstanderKlareForAuksjon' }">Gjenstander Klare For Auksjon</router-link></li>
              <li><router-link :to="{ name: 'StatsProsentandelAvSalgsdagen' }">Prosentandel Av Salgsdagen</router-link></li>
              <li><router-link :to="{ name: 'Vinpakkeliste' }">Pakkeliste, vin</router-link></li>
              <li><router-link :to="{ name: 'Kjoperrapport' }">Store kunder vin</router-link></li>
              <li><router-link :to="{ name: 'RSLink' }">Opprett Resource Space lenke</router-link></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportsList',
  data () {
    return {
    }
  },
  computed: {
    isVin: function () {
      return true // this.$store.getters.getUser.vin
    },
    isAdmin: function () {
      return this.$store.getters.getUser.rolle && this.$store.getters.getUser.rolle.slug === 'admin'
    },
    isExpert: function () {
      return this.$store.getters.getUser.rolle && this.$store.getters.getUser.rolle.slug === 'expert'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/ReportsList.vue